import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button, LilButton } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";
import DropNav from "../DropNav";
import { StyledLink } from "../DropNav/styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      element.scrollIntoView({
        behavior: "smooth",
      });
      setVisibility(false);
    };
    return (
      <>

        {/* <DropNav /> */}
        {/* <CustomNavLinkSmall onClick={() => scrollTo("nutrition")}>
          <Span>{t("Nutrition")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("supplements")}>
          <Span>{t("Supplements")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("training")}>
          <Span>{t("Training")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("sleep")}>
          <Span>{t("Sleep")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("sleep")}>
          <Span>{t("Spirituality")}</Span>
        </CustomNavLinkSmall> */}
        {/* <CustomNavLinkSmall
          style={{ width: "180px" }}
          onClick={() => window.location.href = "tel:+19177453133"}
        >
          <Span>
            <LilButton>{
              <div style={{ color: "white" }}>
                <SvgIcon
                  src="phone.svg"
                  width="24"
                  height="24"
                />
              </div>
            }

            </LilButton>
          </Span>
        </CustomNavLinkSmall> */}
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <div style={{ display: 'flex', justifyContent: "space-between", flexDirection: 'row' }}>
          <LogoContainer to="/" aria-label="homepage">
            {/* <SvgIcon src="SeedBuilders.svg" width="101px" height="101px" /> */}
            <Col>
              <h5 style={{
                fontSize: "30px", fontWeight: "600", textAlign: "center",
                margin: "1.150rem 0 1rem 0", lineHeight: "1.4rem"
              }}>The Seed Builders</h5>
              <h5 style={{
                fontSize: "30px", fontWeight: "600", textAlign: "center",
                margin: "1.150rem 0 1rem 0", lineHeight: "1.4rem"
              }}>Foundation</h5>
            </Col>
          </LogoContainer>
          <NotHidden>
            {/* <MenuItem /> */}
            <DropNav />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </div>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{
            margin: "1.5rem 0.5rem",
            padding: "0.5rem",
            fontSize: "1.3rem",
            lineHeight: "2.6rem" 
            }}>
          <Label onClick={toggleButton}>
            <Col span={12}>
              <Menu>Menu</Menu>
            </Col>
            <Col span={12}>
              <Outline />
            </Col>
          </Label>
          <StyledLink onClick={toggleButton} to="/philosophy">Philosophy</StyledLink>
          <StyledLink onClick={toggleButton} to="/nutrition">Nutrition</StyledLink>
          <StyledLink onClick={toggleButton} to="/supplements">Supplements</StyledLink>
          <StyledLink onClick={toggleButton} to="/training">Training</StyledLink>
          <StyledLink onClick={toggleButton} to="/sleep">Sleep</StyledLink>
          <StyledLink onClick={toggleButton} to="/spirituality">Spirituality</StyledLink>
          <StyledLink onClick={toggleButton} to="/get-involved">Get Involved</StyledLink>
          <StyledLink onClick={toggleButton} to="/circle-time">Circle Time</StyledLink>
          <StyledLink onClick={toggleButton} to="/donate">Donate</StyledLink>
          <StyledLink onClick={toggleButton} to="/about">About</StyledLink>
          <StyledLink onClick={toggleButton} to="/mission">Mission</StyledLink>
          <StyledLink onClick={toggleButton} to="/story">Story</StyledLink>
          <StyledLink onClick={toggleButton} to="/team">Team</StyledLink>
          <StyledLink onClick={toggleButton} to="/impact">Impact</StyledLink>
        </Col>
        <MenuItem />
      </Drawer>
    </Container>
    </HeaderSection >
  );
};

export default withTranslation()(Header);
